/**
 * The scene values for the game.
 *
 * They are defined in order of progression, any "end-game" state
 * will automatically kick you to the MAIN_MENU instantly with no warning.
 */
export enum Scenes {
  SPLASH = 'splash',
  CHARACTER_SELECTION = 'character_selection',
  LANGUAGE_SELECTION = 'language_selection',
  CROWD_CUT = 'crowd_cutscene',
  CROWD = 'crowd',
  GAME_OVER = 'game_over',
  // TODO: maze_cut_scene
  MAZE = 'maze',
  // TODO: maze_cut_scene
  TOWN = 'town',
  // TODO: game_over_cut_scene

  // will only implement if I have time.
  PAUSE_MENU = 'pause_menu',
}

/**
 * Array and order of the scenes.
 *
 * This is defined with only partial support for all scenes, as
 * it is used with the query-param cheats to bypass parts of the game.
 */
export const SCENES = [
  Scenes.CHARACTER_SELECTION,
  Scenes.LANGUAGE_SELECTION,
  Scenes.CROWD_CUT,
  Scenes.CROWD,
  Scenes.GAME_OVER,
  // Scenes.MAZE,
  // Scenes.TOWN,
];
